var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyState',{attrs:{"title":_vm.$t('couldNotLoadContent'),"icon":['fal', 'exclamation-circle']},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('ButtonComponent',{attrs:{"label":_vm.$t('retry'),"icon":['fal', 'sync-alt']},on:{"click":function($event){return _vm.$emit('retry')}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }